import type { AdminDailySalesDB } from "@KassaroAB/shared/types/adminDailySales";
import type { ResellerId } from "@KassaroAB/shared/types/ids";
import { api } from "../utils/api";

export type AdminDailySalesRow = AdminDailySalesDB & { id: string };

const buildDailySalesParams = (
  fromDate: string,
  toDate: string,
  limit: number,
  cursor: string | null
): URLSearchParams => {
  const params = new URLSearchParams({
    fromDate,
    toDate,
    limit: limit.toString(),
  });
  if (cursor) {
    params.set("cursor", cursor);
  }
  return params;
};

export const getAdminDailySalesApi = async (
  fromDate: string,
  toDate: string,
  limit: number = 50,
  cursor: string | null = null
): Promise<AdminDailySalesRow[]> => {
  const params = buildDailySalesParams(fromDate, toDate, limit, cursor);
  return api.get<AdminDailySalesRow[]>(
    `admin/stats/daily-sales?${params.toString()}`
  );
};

export const getResellerDailySalesApi = async (
  resellerId: ResellerId,
  fromDate: string,
  toDate: string,
  limit: number = 50,
  cursor: string | null = null
): Promise<AdminDailySalesRow[]> => {
  const params = buildDailySalesParams(fromDate, toDate, limit, cursor);
  return api.get<AdminDailySalesRow[]>(
    `resellers/${resellerId}/stats/daily-sales?${params.toString()}`
  );
};
